export const INSEE_COUNTRIES = [
  { code: "99212", label: "Afghanistan" },
  { code: "99303", label: "Afrique du Sud" },
  { code: "99160", label: "Åland" },
  { code: "99125", label: "Albanie" },
  { code: "99352", label: "Algérie" },
  { code: "99109", label: "Allemagne" },
  { code: "99130", label: "Andorre" },
  { code: "99395", label: "Angola" },
  { code: "99699", label: "Antarctique" },
  { code: "99441", label: "Antigua-et-Barbuda" },
  { code: "99201", label: "Arabie saoudite" },
  { code: "99415", label: "Argentine" },
  { code: "99252", label: "Arménie" },
  { code: "99431", label: "Aruba" },
  { code: "99501", label: "Australie" },
  { code: "99110", label: "Autriche" },
  { code: "99253", label: "Azerbaïdjan" },
  { code: "99436", label: "Bahamas" },
  { code: "99249", label: "Bahreïn" },
  { code: "99246", label: "Bangladesh" },
  { code: "99434", label: "Barbade" },
  { code: "99131", label: "Belgique" },
  { code: "99429", label: "Bélize" },
  { code: "99327", label: "Bénin" },
  { code: "99214", label: "Bhoutan" },
  { code: "99148", label: "Biélorussie" },
  { code: "99224", label: "Birmanie" },
  { code: "99418", label: "Bolivie" },
  { code: "99443", label: "Bonaire, Saint-Eustache, Saba" },
  { code: "99118", label: "Bosnie-Herzégovine" },
  { code: "99347", label: "Botswana" },
  { code: "99416", label: "Brésil" },
  { code: "99225", label: "Brunei" },
  { code: "99111", label: "Bulgarie" },
  { code: "99331", label: "Burkina" },
  { code: "99321", label: "Burundi" },
  { code: "99234", label: "Cambodge" },
  { code: "99322", label: "Cameroun" },
  { code: "99401", label: "Canada" },
  { code: "99396", label: "Cap-Vert" },
  { code: "99323", label: "Centrafrique" },
  { code: "99417", label: "Chili" },
  { code: "99216", label: "Chine" },
  { code: "99254", label: "Chypre" },
  { code: "99419", label: "Colombie" },
  { code: "99397", label: "Comores" },
  { code: "99324", label: "Congo" },
  { code: "99520", label: "Cook" },
  { code: "99238", label: "Corée du Nord" },
  { code: "99239", label: "Corée du Sud" },
  { code: "99406", label: "Costa Rica" },
  { code: "99326", label: "Côte d’Ivoire" },
  { code: "99119", label: "Croatie" },
  { code: "99407", label: "Cuba" },
  { code: "99444", label: "Curaçao" },
  { code: "99101", label: "Danemark" },
  { code: "99161", label: "Dépendances de la Couronne britannique" },
  { code: "99399", label: "Djibouti" },
  { code: "99438", label: "Dominique" },
  { code: "99301", label: "Égypte" },
  { code: "99247", label: "Émirats arabes unis" },
  { code: "99420", label: "Équateur" },
  { code: "99317", label: "Érythrée" },
  { code: "99134", label: "Espagne" },
  { code: "99106", label: "Estonie" },
  { code: "99404", label: "États-Unis" },
  { code: "99315", label: "Éthiopie" },
  { code: "99158", label: "Féroé" },
  { code: "99508", label: "Fidji" },
  { code: "99105", label: "Finlande" },
  { code: "99100", label: "France" },
  { code: "99328", label: "Gabon" },
  { code: "99304", label: "Gambie" },
  { code: "99255", label: "Géorgie" },
  { code: "99329", label: "Ghana" },
  { code: "99126", label: "Grèce" },
  { code: "99435", label: "Grenade" },
  { code: "99430", label: "Groenland" },
  { code: "99409", label: "Guatémala" },
  { code: "99330", label: "Guinée" },
  { code: "99314", label: "Guinée équatoriale" },
  { code: "99392", label: "Guinée-Bissao" },
  { code: "99428", label: "Guyana" },
  { code: "99410", label: "Haïti" },
  { code: "99411", label: "Honduras" },
  { code: "99230", label: "Hong Kong" },
  { code: "99112", label: "Hongrie" },
  { code: "99162", label: "Île des Faisans" },
  { code: "99223", label: "Inde" },
  { code: "99231", label: "Indonésie" },
  { code: "99203", label: "Irak" },
  { code: "99204", label: "Iran" },
  { code: "99136", label: "Irlande" },
  { code: "99102", label: "Islande" },
  { code: "99207", label: "Israël" },
  { code: "99127", label: "Italie" },
  { code: "99426", label: "Jamaïque" },
  { code: "99217", label: "Japon" },
  { code: "99222", label: "Jordanie" },
  { code: "99256", label: "Kazakhstan" },
  { code: "99332", label: "Kenya" },
  { code: "99257", label: "Kirghizstan" },
  { code: "99513", label: "Kiribati" },
  { code: "99157", label: "Kosovo" },
  { code: "99240", label: "Koweït" },
  { code: "99241", label: "Laos" },
  { code: "99348", label: "Lesotho" },
  { code: "99107", label: "Lettonie" },
  { code: "99205", label: "Liban" },
  { code: "99302", label: "Libéria" },
  { code: "99316", label: "Libye" },
  { code: "99113", label: "Liechtenstein" },
  { code: "99108", label: "Lituanie" },
  { code: "99137", label: "Luxembourg" },
  { code: "99232", label: "Macao" },
  { code: "99156", label: "Macédoine du Nord" },
  { code: "99333", label: "Madagascar" },
  { code: "99227", label: "Malaisie" },
  { code: "99334", label: "Malawi" },
  { code: "99229", label: "Maldives" },
  { code: "99335", label: "Mali" },
  { code: "99144", label: "Malte" },
  { code: "99350", label: "Maroc" },
  { code: "99515", label: "Marshall" },
  { code: "99390", label: "Maurice" },
  { code: "99336", label: "Mauritanie" },
  { code: "99405", label: "Mexique" },
  { code: "99516", label: "Micronésie" },
  { code: "99151", label: "Moldavie" },
  { code: "99138", label: "Monaco" },
  { code: "99242", label: "Mongolie" },
  { code: "99120", label: "Monténégro" },
  { code: "99393", label: "Mozambique" },
  { code: "99311", label: "Namibie" },
  { code: "99507", label: "Nauru" },
  { code: "99215", label: "Népal" },
  { code: "99412", label: "Nicaragua" },
  { code: "99337", label: "Niger" },
  { code: "99338", label: "Nigéria" },
  { code: "99521", label: "Niue" },
  { code: "99103", label: "Norvège" },
  { code: "99502", label: "Nouvelle-Zélande" },
  { code: "99250", label: "Oman" },
  { code: "99339", label: "Ouganda" },
  { code: "99258", label: "Ouzbékistan" },
  { code: "99213", label: "Pakistan" },
  { code: "99517", label: "Palaos" },
  { code: "99261", label: "Palestine" },
  { code: "99413", label: "Panama" },
  { code: "99510", label: "Papouasie-Nouvelle-Guinée" },
  { code: "99421", label: "Paraguay" },
  { code: "99135", label: "Pays-Bas" },
  { code: "99422", label: "Pérou" },
  { code: "99220", label: "Philippines" },
  { code: "99503", label: "Pitcairn" },
  { code: "99122", label: "Pologne" },
  { code: "99139", label: "Portugal" },
  { code: "99248", label: "Qatar" },
  { code: "99312", label: "République démocratique du Congo" },
  { code: "99408", label: "République dominicaine" },
  { code: "99114", label: "Roumanie" },
  { code: "99132", label: "Royaume-Uni" },
  { code: "99123", label: "Russie" },
  { code: "99340", label: "Rwanda" },
  { code: "99389", label: "Sahara occidental" },
  { code: "99442", label: "Saint-Christophe-et-Niévès" },
  { code: "99128", label: "Saint-Marin" },
  { code: "99445", label: "Saint-Martin (partie néerlandaise)" },
  { code: "99440", label: "Saint-Vincent-et-les-Grenadines" },
  { code: "99439", label: "Sainte-Lucie" },
  { code: "99512", label: "Salomon" },
  { code: "99414", label: "Salvador" },
  { code: "99506", label: "Samoa" },
  { code: "99394", label: "Sao Tomé-et-Principe" },
  { code: "99341", label: "Sénégal" },
  { code: "99121", label: "Serbie" },
  { code: "99398", label: "Seychelles" },
  { code: "99342", label: "Sierra Leone" },
  { code: "99226", label: "Singapour" },
  { code: "99117", label: "Slovaquie" },
  { code: "99145", label: "Slovénie" },
  { code: "99318", label: "Somalie" },
  { code: "99343", label: "Soudan" },
  { code: "99349", label: "Soudan du Sud" },
  { code: "99235", label: "Sri Lanka" },
  { code: "99104", label: "Suède" },
  { code: "99140", label: "Suisse" },
  { code: "99437", label: "Suriname" },
  { code: "99391", label: "Swaziland" },
  { code: "99206", label: "Syrie" },
  { code: "99259", label: "Tadjikistan" },
  { code: "99236", label: "Taïwan" },
  { code: "99309", label: "Tanzanie" },
  { code: "99344", label: "Tchad" },
  { code: "99116", label: "Tchéquie" },
  { code: "99363", label: "Terres australes norvégiennes" },
  { code: "99446", label: "Territoire antarctique argentin" },
  { code: "99447", label: "Territoire antarctique chilien" },
  { code: "99308", label: "Territoire britannique de l’océan Indien" },
  { code: "99265", label: "Territoires australiens de l’océan Indien" },
  { code: "99427", label: "Territoires britanniques dans l’océan Atlantique Sud" },
  { code: "99425", label: "Territoires britanniques dans les Antilles et Bermudes" },
  { code: "99306", label: "Territoires britanniques de l’océan Atlantique" },
  { code: "99133", label: "Territoires britanniques en Méditerranée" },
  { code: "99522", label: "Territoires de l’Australie en Océanie" },
  { code: "99519", label: "Territoires de la Nouvelle-Zélande" },
  { code: "99432", label: "Territoires des États-Unis en Amérique" },
  { code: "99505", label: "Territoires des États-Unis en Océanie" },
  { code: "99313", label: "Territoires espagnols en Afrique du Nord" },
  { code: "99159", label: "Territoires norvégiens en Atlantique Nord" },
  { code: "99319", label: "Territoires portugais de l’océan Atlantique" },
  { code: "99219", label: "Thaïlande" },
  { code: "99262", label: "Timor oriental" },
  { code: "99345", label: "Togo" },
  { code: "99509", label: "Tonga" },
  { code: "99433", label: "Trinité-et-Tobago" },
  { code: "99351", label: "Tunisie" },
  { code: "99260", label: "Turkménistan" },
  { code: "99208", label: "Turquie" },
  { code: "99511", label: "Tuvalu" },
  { code: "99155", label: "Ukraine" },
  { code: "99423", label: "Uruguay" },
  { code: "99514", label: "Vanuatu" },
  { code: "99129", label: "Vatican" },
  { code: "99424", label: "Vénézuéla" },
  { code: "99243", label: "Vietnam" },
  { code: "99251", label: "Yémen" },
  { code: "99346", label: "Zambie" },
  { code: "99310", label: "Zimbabwe" },
];
